export const GET_ACTION = 'GET_ACTION';
export const GET_ACTION_FULFILLED = 'GET_ACTION_FULFILLED';
export const GET_ACTION_REJECTED = 'GET_ACTION_REJECTED';

export const EXECUTE_ACTION = 'EXECUTE_ACTION';
export const EXECUTE_ACTION_FULFILLED = 'EXECUTE_ACTION_FULFILLED';
export const EXECUTE_ACTION_REJECTED = 'EXECUTE_ACTION_REJECTED';
